
  import { mapState } from 'vuex'
  import baseLogic from '~/mixins/base-logic'
  export default {
    name: 'LanguageSwitcher',
    mixins: [baseLogic],
    props: {
      languages: {
        type: Array,
        default: () => []
      }
    },
    computed: {
      ...mapState({
        supportCountryAndLanguage: state => state.settings.supportCountryAndLanguage
      })
    },
    methods: {
      isActiveLanguage(item) {
        return item?.supported_languages?.filter(el => el?.is_active || el?.is_default)
      }
    }
  }
